<template>
    <!-- サイレント -->
    <fieldset id="silent">
        <legend>コマンド進行形式</legend>
        <div>
            コマンドを対話型で実行するか、非対話型で実行するかを選択してください。<br>
            非対話型で実行する場合は、コマンド実行時に入力が必要な項目を全て入力してください。<br>
            対話型で実行する場合は、コマンド実行時に入力が必要な項目を入力しなくても、コマンド実行時に入力を求められます。
        </div>
        <div class="form-area">
            <input type="radio" class="input-radio" id="notSilentRadio" v-model="silentFormData" name="silentRadio"
                :value="false" @change="updateOpt">
            <label for="notSilentRadio">対話型: 入力待ちが発生します</label><br>
            <input type="radio" class="input-radio" id="silentRadio" v-model="silentFormData" name="silentRadio"
                :value="true" @change="updateOpt" checked>
            <label for="silentRadio">非対話型: 入力待ちが発生しません(推奨)</label><br>
        </div>
    </fieldset>
</template>

<script>
import { onMounted, ref } from 'vue';

import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'SilentForm',
    setup(_, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const silentFormData = ref(true)

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            // サイレント
            let createdOpt = ""
            if (silentFormData.value) {
                createdOpt += "--silent"
            }

            // cacheに保存
            await cacheUtils.saveData("silent", silentFormData.value)

            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "silent", createdOpt)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            silentFormData.value = await cacheUtils.getData("silent", true)

            await updateOpt()
        })

        return {
            // フォームデータ
            silentFormData,
            // コマンド生成
            updateOpt,
        }
    }
}
</script>
